import AppStateService from '@ajs/services/AppStateService';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LinkService } from '@app/core/services/link.service';
import { LocalStorageService } from '@app/core/services/local-storage.service';

@Injectable({
    providedIn: 'root'
})
export class ExportsRoutingService {

    private get localStorageKey(): string {
        return `new-exports-${this.appStateService.getUserId()}`;
    }

    get shouldUseNewExports(): boolean {
        const preference = this.localStorageService.getItem(this.localStorageKey);
        return preference !== 'legacy';
    }

    private readonly appStateService: AppStateService = inject(AppStateService);
    private readonly linkService: LinkService = inject(LinkService);
    private readonly localStorageService: LocalStorageService = inject(LocalStorageService);
    private readonly router: Router = inject(Router);

    switchToLegacy(): void {
        this.localStorageService.setItem(this.localStorageKey, 'legacy');
    }
    
    navigateToLegacyFlow(queryParams?: Record<string, string | boolean>): void {
        void this.router.navigate(this.linkService.exportsLegacyLink, { queryParams });
    }

    switchToNewFlow(): void {
        this.localStorageService.setItem(this.localStorageKey, 'current');
    }

    switchAndNavigateToNewFlow(link?: string[]): void {
        this.localStorageService.setItem(this.localStorageKey, 'current');
        void this.router.navigate(link ?? this.linkService.exportsListLink);
    }
}
